import { apiSlice } from '../../../app/api/apiSlice';
import Config from '../../../configs/appConfig';
import makeQueryParams from '../../../lib/makeQueryParams';



export const PushNotificationsScheduleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    return ({
      getPushNotificationsSchedule: builder.query({
        query: (params) => {
          const queryParams = makeQueryParams(params.queryParams);

          return ({ url: `/${Config.VITE_HC_API_VERSION}/push-notifications-schedule${queryParams}${params?.includes || ''}` });
        },
        transformResponse: (response) => {
          return {
            data: response?.data,
            pagination: response?.meta?.pagination,
          };
        },
        transformErrorResponse: (response) => response?.data?.errors,
        providesTags: [ 'PushNotificationsSchedule' ],
        keepUnusedDataFor: 1,
      }),
      getSpecificPushNotificationSchedule: builder.query({
        query: ({ scheduleId }) => ({ url: `/${Config.VITE_HC_API_VERSION}/push-notifications-schedule/${scheduleId}` }),
        transformResponse: (response) => response.data,
        providesTags: [ 'PushNotificationsScheduleItem' ],
      }),
      createPushNotificationSchedule: builder.mutation({
        query: (values) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications-schedule`,
          method: 'POST',
          body: values,
        }),
        invalidatesTags: () => [ 'PushNotifications', 'PushNotificationsSchedule' ],
      }),
      updatePushNotificationSchedule: builder.mutation({
        query: ({ id, values }) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications-schedule/${id}`,
          method: 'PUT',
          body: values,
        }),
        invalidatesTags: () => [ 'PushNotifications', 'PushNotificationsSchedule', 'PushNotificationsScheduleItem' ],
      }),
      deletePushNotificationSchedule: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications-schedule/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: () => [ 'PushNotificationsSchedule' ],
      }),
      unpublishPushNotificationSchedule: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/push-notifications-schedule/${id}/unpublish`,
          method: 'POST',
        }),
        invalidatesTags: () => [ 'PushNotifications', 'PushNotificationsSchedule', 'PushNotificationsScheduleItem' ],
      }),
    });
  },
});

export const {
  useGetPushNotificationsScheduleQuery,
  useGetSpecificPushNotificationScheduleQuery,
  useCreatePushNotificationScheduleMutation,
  useUpdatePushNotificationScheduleMutation,
  useDeletePushNotificationScheduleMutation,
  useUnpublishPushNotificationScheduleMutation,
} = PushNotificationsScheduleApiSlice;
